export default "__VITE_ASSET__LZcpT9ZW__"